jQuery($ => {
  class ProductFeed {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._AjaxRunning = 0;

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      $(window).on('load ajax', () => {
        if ($('.o-product-feed__filters-form')[0]) {
          const form = $('.o-product-feed__filters-form');

          form.on('submit', (e) => {
            if (form.attr('data-ajax') === 'true') {
              e.preventDefault();
              this.handleSubmit();
            }
          });

          form.on('reset', (e) => {
            this.handleReset();
          });

          form.find('input, select').on('change', () => {
            form.submit();
          });
        }

        $('.o-product-feed .page-numbers').click((e) => {
          e.preventDefault();

          let page = parseInt($(e.target).text());

          this.handleSubmit(page);
        })
      });

      if ($(this._element)[0]) {
        $(window).on('popstate', (e) => {
          if (e.originalEvent.state !== null) {
            if (e.originalEvent.state.feed) {
              $(this._element).html(e.originalEvent.state.feed);

              setTimeout(() => {
                $(this._element).find('.m-accordion').each((index, element) => {
                  $(element).accordion();
                });

                $(this._element).find('.m-add-to-quote-button').each((index, element) => {
                  $(element).add_to_quote_button();
                });

                $(this._element).find('.page-numbers').click((e) => {
                  e.preventDefault();
                  let page = parseInt($(e.target).text());

                  this.handleSubmit(page);
                });

                if ($('.o-product-feed__filters-form')[0]) {
                  const form = $('.o-product-feed__filters-form');

                  form.on('submit', (e) => {
                    e.preventDefault();
                    this.handleSubmit();
                  });

                  form.find('input, select').on('change', () => {
                    form.submit();
                  });
                }
              }, 100);
            }
          }
        });
      }
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Get Page
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    handleGetPage = () => {
      var page = 1;

      if ($(this)[0].className.includes('page-numbers')) {
        page = parseInt($(this).text());
      }

      return page;
    };

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Reset
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    handleReset = () => {
      $(this._form)[0].reset();

      this.handleSubmit(0, true);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Submit
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleSubmit = (page, isReset) => {
      const form = $('.o-product-feed__filters-form');
      const pageInput = form.find('input[name="paged"]');

      if (pageInput[0] && page >= 1) {
        pageInput.val(page);
      }

      let formData = form.serialize();

      if (isReset) {
        formData = '';

        const pageSize = this._form.find('select[name="page_size"]');
        if (pageSize[0]) {
          formData += `page_size=${pageSize.val()}`;
        }
      }

      formData += '&action=load_filtered_products';
      formData += this._element.data('is-product-category') !== false ? `&is_product_category=${this._element.data('is-product-category')}` : '';
      formData += this._element.data('product-category') ? `&category=${this._element.data('product-category')}` : '';

      $.ajax({
        type: 'POST',
        url: AJAX.url,
        data: formData,
        beforeSend: () => {
          this._AjaxRunning++;
        },
        success: (response) => {
          if (response.data.feed) {
            $('.o-product-feed').replaceWith(response.data.feed);

            setTimeout(() => {
              $('.o-product-feed').find('.m-add-to-quote-button').each(function () {
                $(this).add_to_quote_button();
              });
            }, 100);
          }

          if (page) {
            const y = $('.o-product-feed__main')[0].getBoundingClientRect().top + window.scrollY + -180;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
          $(window).trigger('ajax');
        },
        error: (error) => {
          console.error(error);
        },
        complete: () => {
          this._AjaxRunning--;
          this._element.removeClass('o-product-feed--loading');
        }
      })
    }

  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.product_feed = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].product_feed = new ProductFeed(_[i], opt);
      else
        ret = _[i].product_feed[opt].apply(_[i].product_feed, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-product-feed').product_feed();
});